export const getBackofficeAllowedRoles = (): string[] =>
  [
    process.env.REACT_APP_COGNITO_ROLE,
    process.env.REACT_APP_COGNITO_SUPER_ADMIN_ROLE ?? "SUPER_ADMIN",
    process.env.REACT_APP_COGNITO_TENANT_ADMIN_ROLE ?? "TENANT_ADMIN",
  ].filter((role): role is string => Boolean(role));

export const hasBackofficeRole = (sessionRoles: string[]): boolean => {
  const allowedRoles = getBackofficeAllowedRoles();
  return sessionRoles.some((role) => allowedRoles.includes(role));
};

export const isGlobalFeatureFlagAdmin = (sessionRoles: string[]): boolean => {
  const legacyAdmin = process.env.REACT_APP_COGNITO_ROLE ?? "adminbo";
  const superAdminRole = process.env.REACT_APP_COGNITO_SUPER_ADMIN_ROLE ?? "SUPER_ADMIN";
  return sessionRoles.includes(legacyAdmin) || sessionRoles.includes(superAdminRole);
};

export const isTenantFeatureFlagAdmin = (sessionRoles: string[]): boolean => {
  const tenantAdminRole = process.env.REACT_APP_COGNITO_TENANT_ADMIN_ROLE ?? "TENANT_ADMIN";
  return sessionRoles.includes(tenantAdminRole);
};
